<div class="padded-content legal-content">
  <app-policy></app-policy>
</div>

